import { render, staticRenderFns } from "./bills-buttons.vue?vue&type=template&id=1f752aca&scoped=true"
import script from "./bills-buttons.vue?vue&type=script&lang=js"
export * from "./bills-buttons.vue?vue&type=script&lang=js"
import style0 from "./bills-buttons.vue?vue&type=style&index=0&id=1f752aca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f752aca",
  null
  
)

export default component.exports